<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-title>{{ context.pageTitle | translate }}</glxy-page-title>
  </glxy-page-toolbar>
  <!-- No glxy-page-wrapper: we want the content to fill the page main
       area so the table body can scroll internally with the
       tab-switcher and the table's own search / headers / paginator
       all remaining visible. -->
  <div class="page-content">
    <div class="tab-switcher">
      <mat-button-toggle-group [value]="activeTab()" (change)="activeTab.set($event.value)">
        <mat-button-toggle value="sources">Knowledge sources</mat-button-toggle>
        <mat-button-toggle value="bases">Knowledge bases</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    @if (activeTab() === 'sources') {
      <ai-knowledge-knowledge-source-table
        [rows]="ksRowsData()"
        [editingEnabled]="editingEnabled()"
        [rawSourcesById]="rawSourcesById()"
        (changed)="onSourcesChanged()"
      />
    }

    @if (activeTab() === 'bases') {
      <ai-knowledge-knowledge-base-table
        [rows]="kbRowsData()"
        [sources]="ksRowsData()"
        [editingEnabled]="editingEnabled()"
        [canShare]="canShareEffective()"
        [persist]="persistChanges()"
        (rowsChange)="kbRowsData.set($event)"
      />
    }
  </div>
</glxy-page>
